import PropTypes from 'prop-types';
import useFeatureToggle from './useFeatureToggle';

const FeatureToggle = ({ children, name, whenDisabled }) => {
  const featureToggle = useFeatureToggle(name);
  if (featureToggle && !whenDisabled) {
    return children;
  } else if (!featureToggle && whenDisabled) {
    return children;
  }
  return null;
};

FeatureToggle.propTypes = {
  name: PropTypes.string.isRequired,
  whenDisabled: PropTypes.bool,
};

export default FeatureToggle;
